// extracted by mini-css-extract-plugin
export default {"productDetailHeader":"ProvinceCard_productDetailHeader__ru8WA","icons":"ProvinceCard_icons__g1XDz"};